export type ExportGateMode = 'quiz' | 'lead' | 'none';

export const brand = {
  name: 'WALLD',
  productName: 'Tattoo Try-On',
  logo: '/branding/walld-logo-dark.svg',
  mark: '/branding/walld-mark-dark.svg',
  accent: '#2563FF',
  supportHandle: '@walldstudio',
  botUsername: import.meta.env.VITE_TELEGRAM_BOT_USERNAME || '',
} as const;

export const featureFlags = {
  exportGateMode: (import.meta.env.VITE_EXPORT_GATE_MODE || 'quiz') as ExportGateMode,
  resultPrimaryCta: import.meta.env.VITE_RESULT_PRIMARY_CTA || 'booking',
  firstScreenVariant: import.meta.env.VITE_FIRST_SCREEN_VARIANT || 'direct',
  b2bRevealVariant: import.meta.env.VITE_B2B_REVEAL_VARIANT || 'lead_card_first',
  showWalldBranding: (import.meta.env.VITE_SHOW_WALLD_BRANDING || 'true') !== 'false',
  editorHistorySafetyLimit: Math.max(500, Number(import.meta.env.VITE_EDITOR_HISTORY_SAFETY_LIMIT || 2000)),
} as const;

export const SHOW_WALLD_BRANDING = featureFlags.showWalldBranding;

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');
